import { isValidElement, ReactNode } from "react";

const getTrackingId = (
  node: ReactNode,
  scope: "but" | "node" | "select-nav" = "but",
  fallback = "default",
): string => {
  const prefix = `id-${scope}-`;
  if (typeof node === "string") {
    return sluggify(node, prefix);
  }
  if (
    isValidElement(node) &&
    typeof node.props === "object" &&
    node.props !== null &&
    "children" in node.props &&
    typeof node.props.children === "string"
  ) {
    return sluggify(node.props.children, prefix);
  }
  return sluggify(fallback, prefix);
};

const sluggify = (str: string, prefix: string) => {
  const slug = str.toLowerCase().replaceAll(/\s+/g, "-");
  return `${prefix}${slug}`;
};

/* Creates tracking id for buttons */
export const tb = (node: ReactNode) => {
  return getTrackingId(node, "but");
};

/* Creates tracking id for nodes */
export const tn = (node: ReactNode) => {
  return getTrackingId(node, "node");
};

/* Creates tracking id for selects */
export const ts = (node: ReactNode) => {
  return getTrackingId(node, "select-nav");
};
